import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { LitPage } from '../lit-page';
import '../luna-icon/luna-icon';

@customElement('luna-custom-board-card')
export class LunaCustomBoardCard extends LitPage {
  private emitConfigure(): void {
    this.dispatchEvent(
      new CustomEvent('luna-configure', {
        detail: {},
        bubbles: true,
        composed: true,
      })
    );
  }

  content() {
    return html`
      <div class="luna-custom-board-card">
        <luna-icon
          class="luna-custom-board-card__icon"
          name="sliders"
          size="28"
          aria-hidden="true"
        ></luna-icon>
        <div class="luna-custom-board-card__txt">
          <span class="luna-custom-board-card__title mbw-type-label-button-xl">Custom board</span>
          <span class="luna-custom-board-card__subtitle mbw-type-body-small"
            >Set your own size and difficulty</span
          >
        </div>
        <button type="button" class="luna-custom-board-card__play" @click=${this.emitConfigure}>
          <luna-icon name="play" size="18" aria-hidden="true"></luna-icon>
          <span class="luna-custom-board-card__play-label">Play</span>
        </button>
      </div>
    `;
  }

  styles() {
    return css`
      .luna-custom-board-card {
        display: flex;
        align-items: center;
        gap: 14px;
        width: 100%;
        height: 84px;
        box-sizing: border-box;
        padding: 14px 18px;
        border-radius: var(--luna-radius-card-sm);
        background-image: linear-gradient(180deg, #ffffff 0%, #f1f5fc 100%); /* pinned: figma Custom Board Card */
        box-shadow: inset 0 0 0 2px var(--luna-outline-checkpoint),
          0 3px 0 var(--luna-outline-checkpoint-ledge);
      }

      .luna-custom-board-card__icon {
        color: var(--cds-blue-60);
      }

      .luna-custom-board-card__txt {
        display: flex;
        flex-direction: column;
        gap: 2px;
        min-width: 0;
        flex: 1;
      }

      .luna-custom-board-card__title {
        color: var(--cds-blue-60);
      }

      .luna-custom-board-card__subtitle {
        color: var(--mbw-text-body);
      }

      .luna-custom-board-card__play {
        flex-shrink: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        width: 120px;
        height: 56px;
        padding: 0 26px;
        box-sizing: border-box;
        border: none;
        border-radius: var(--luna-radius-btn);
        cursor: pointer;
        color: var(--cds-blue-60);
        background: #eaf1ff; /* pinned: figma Custom Board Card */
        box-shadow: inset 0 0 0 2px var(--luna-outline-checkpoint);
      }

      .luna-custom-board-card__play:focus-visible {
        outline: none;
        box-shadow:
          inset 0 0 0 2px var(--luna-outline-checkpoint),
          0 0 0 5px #ffffff,
          0 0 0 7px var(--cds-focus);
      }

      .luna-custom-board-card__play-label {
        font-family: var(--mbw-font-sans);
        font-weight: 700;
        font-size: 21px; /* pinned: figma Custom Board Card (drift vs 19px Play/Label) */
        line-height: 27px;
        color: var(--cds-blue-60);
      }
    `;
  }
}
